import { useContext } from 'react';

import ThemeContext from './ThemeContext.jsx';

export const useTheme = () => {
    const { theme } = useContext(ThemeContext);

    return theme;
};
